import DatePicker, { registerLocale } from "react-datepicker";
import ru from "date-fns/locale/ru";
import { getMonth, getYear } from "date-fns";
import range from "lodash/range";
import "react-datepicker/dist/react-datepicker.css";

registerLocale("ru", ru);

const years = range(2024, getYear(new Date()) + 5, 1);
const months = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

const CustomDatePicker = ({
  startDate,
  endDate,
  onChange,
  isClearable = true,
  className = "datepicker-custom-input-dash",
  selectsRange = true,
  ...props
}) => {
  return (
    <DatePicker
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div
          style={{
            margin: 10,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            className="btn btn-sm btn-light btn-active-light-primary"
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
            type="button"
          >
            {"<"}
          </button>
          <select
            style={{
              margin: "0 5px",
              border: "1px solid #ced4da",
              borderRadius: "4px",
            }}
            value={getYear(date)}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            style={{
              margin: "0 5px",
              border: "1px solid #ced4da",
              borderRadius: "4px",
            }}
            value={months[getMonth(date)]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <button
            className="btn btn-sm btn-light btn-active-light-primary"
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
            type="button"
          >
            {">"}
          </button>
        </div>
      )}
      selected={startDate}
      startDate={startDate}
      endDate={endDate}
      onChange={onChange}
      selectsRange={selectsRange}
      isClearable={isClearable}
      locale="ru"
      className={className}
      dateFormat="dd.MM.yyyy"
      {...props}
    />
  );
};

export default CustomDatePicker;
